import { Injectable } from '@angular/core';


@Injectable()
export class AppGlobals {

  constructor() {

  }

  //readonly baseAPIUrl: string = 'http://localhost:60345/'; 
  //production : 251 / Development
  //readonly baseAPIUrl: string = 'http://pdc-srv-dtrc01:251/'; 
  //readonly baseAPIUrl: string = 'http://pdc-srv-dtrc01:2030/Services/'; 
  readonly baseAPIUrl: string = 'https://bodylinemvd.masholdings.com/services/';
  //quality : 252
  //readonly baseAPIUrl: string = 'http://pdc-srv-dtrc01:252/';
  //Dev : 265
  //readonly baseAPIUrl: string = 'http://pdc-srv-dtrc01:265/';

}
